import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_DM_REPUTATION_LAYER = defineFcm('dm_reputation_layer')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		enabled: false,
	})
	.withMerger(({ localeValue, countryValue, globalValue }) => ({
		// Priority: If locale and country are enabled, use that
		// If not, fall back to global value
		enabled: (localeValue.enabled && countryValue.enabled) || globalValue.enabled,
	}))
	.toConfig({
		owner: 'squad-capybara',
		scope: 'corgi-front-end',
		context: 'DM Reputation Layer',
		description: 'Feature flag to enable the DM Reputation Layer on DM profile page',
		mergeLogic: 'If both locale and country are enabled, feature is enabled. Otherwise falls back to global value.',
		import: false,
		template: {
			enabled: false,
		},
	});
